// extracted by mini-css-extract-plugin
export var divider = "_wa-0";